import React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import FormGrupoImpostoItem from '../form-grupo-imposto-item/index';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    tableWrapper: {
        maxHeight: 440,
        overflow: 'auto',
    },
}));


export default function ListagemGrupoImpostoItem(props) {

    const { impostos, adicionarImpostos, removerImposto } = props;
    const classes = useStyles();

    return (
        <>
            <h1>Itens</h1>
            <Paper className={classes.root}>
                <div className={classes.tableWrapper}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ação</TableCell>
                                <TableCell>Imposto</TableCell>
                                <TableCell >Base</TableCell>
                                <TableCell >Aliquota</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {impostos.map((imposto, indexImposto) => (
                                <TableRow key={imposto.codigoItem}>
                                    <TableCell>
                                        <FormGrupoImpostoItem
                                            adicionarImpostos={adicionarImpostos}
                                            removerImposto={removerImposto}
                                            grid="true"
                                            imposto={imposto}
                                            indexImposto={indexImposto}
                                        />
                                    </TableCell>
                                    <TableCell>{imposto.codigoImposto}</TableCell>
                                    <TableCell>{imposto.base}</TableCell>
                                    <TableCell>{imposto.aliquota}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Paper>
        </>

    )
}